const appInfo = {
    title: 'Sage Sync'
};
export default appInfo;

